// extracted by mini-css-extract-plugin
export var box = "_4z-0";
export var check = "_4z-1";
export var checkboxButton = "_4z-6";
export var checkboxGroup = "_4z-5";
export var disabled = "_4z-7";
export var ghost = "_4z-9";
export var input = "_4z-2";
export var label = "_4z-4";
export var normal = "_4z-8";
export var uncheck = "_4z-3";